import React, { useEffect, useState } from 'react';
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { OrderService } from './service/OrderService';
import { DataTable } from 'primereact/datatable';
import { DataView } from 'primereact/dataview';
import { Column } from 'primereact/column';
import { add, startOfWeek, endOfWeek, eachWeekOfInterval, formatISO, parseISO, isSameWeek, set } from 'date-fns';
import { formatDayAndDate, formatTime, formatDay } from '../utils.js';
import { CSVLink } from "react-csv";
import { MultiSelect } from 'primereact/multiselect';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';
import { Chip } from 'primereact/chip';
import './WeeklySummary.css';
import { isWithinInterval, format } from 'date-fns';
import { FilterMatchMode, FilterOperator } from 'primereact/api';


const WeeklySummary = () => {
  const defaultDateRange = {
    start: new Date().toISOString(),
    end: add(new Date(), { days: 90 }).toISOString()
  };

  const [orders, setOrders] = useState([]);
  const [sorted, setSorted] = useState(false);
  const [csvReport, setCsvReport] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [displayDialog, setDisplayDialog] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [assignee, setAssignee] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [note, setNote] = useState("");
  const [description, setDescription] = useState("");
  const [scrollHeight, setScrollHeight] = useState('1000px');

  const storedDateRange = localStorage.getItem('dateRange_');
  const initialDateRange = storedDateRange
    ? JSON.parse(storedDateRange)
    : defaultDateRange;

  const [dateRange, setDateRange] = useState({
    start: new Date(initialDateRange.start),
    end: new Date(initialDateRange.end)
  });

  useEffect(() => {
    OrderService.getOrdersByDateRange(dateRange.start, dateRange.end).then(data => {
      console.log("Orders: ", data);  // Log the orders data
      setOrders(data);

      const csvReport = {
        data: jsonToCSV(data),
        headers: Object.keys(data[0]),
        filename: 'OrderReport.csv'
      }

      setCsvReport(csvReport);
    });

    OrderService.getEmployees().then(data => {
      console.log("Employees: ", data);  // Log the employees data
      setEmployees(data);
    });
    
  }, []);

  useEffect(() => {
    console.log("employees: ", employees);
  }, [employees]);

  async function refreshOrders() {
    OrderService.getOrdersByDateRange(dateRange.start, dateRange.end).then(data => {
      setOrders(data);
    });
  };

  const getEmployeesByRole = (role) => {
    return employees.filter(employee => employee.roles.includes(role)).map(employee => ({ label: employee.name, value: employee.name }));
  };

  const getEmployee = (employeeName) => {
    return employees.find(employee => employee.name === employeeName);
  };


  useEffect(() => {
    const stringifiedDateRange = {
      start: dateRange.start.toISOString(),
      end: dateRange.end.toISOString()
    };
    localStorage.setItem('dateRange_', JSON.stringify(stringifiedDateRange));
  }, [dateRange]);

  const sortAndFilterOrders = () => {
    const weeks = eachWeekOfInterval({
      start: dateRange.start,
      end: dateRange.end
    }, { weekStartsOn: 1 });

    if (sorted) {
      return weeks.sort((a, b) => b - a); // For descending order
    }
    return weeks.sort((a, b) => a - b); // For ascending order
  };

  const dueList = (week) => {
    return orders.filter((order) => {
      const date = parseISO(order.dueDate);
      return isSameWeek(date, week, { weekStartsOn: 1 });
    });
  };



  // Create a function to open the dialog
  const openDialog = (order, item, roleType) => {
    setSelectedItem({
      orderId: order._id,
      _id: item._id,
      roleType
    });
    switch (roleType) {
      case 'Baker':
        setAssignee(item.assignedBaker);
        setDueDate(item.bakingDate ? new Date(item.bakingDate) : null);
        setNote(item.bakingNotes);
        break;
      case 'Toppers':
      case 'Details':
        setAssignee(item.assignedPerson);
        setDueDate(item.dueDate ? new Date(item.dueDate) : null);
        setNote(item.note);
        setDescription(item.description);
        break;  // added break statement here
      case 'Decorator':
        setAssignee(item.assignedDecorator);
        setDueDate(item.decoratingDate ? new Date(item.decoratingDate) : null);
        setNote(item.decoratingNotes);
        break;
      case 'Crumb Coater':
        setAssignee(item.assignedCrumbCoater);
        setDueDate(item.crumbCoatDate ? new Date(item.crumbCoatDate) : null);
        setNote(item.crumbCoatNote);
        break;
      default:
        break;
    }

    setDisplayDialog(true);
  };

  const getEmployeeColor = ({_employees, employee}) => {
    const employeeObj = _employees.find(e => e.name === employee);
    console.log("employees: ", _employees);
    console.log("Employee: ", employeeObj);
    return employeeObj ? employeeObj.color : '#f7f7f7';
  };

  const content = (employee) => {
    return (
      <>
        <span className="bg-primary border-circle w-2rem h-2rem flex align-items-center justify-content-center">{employee.split(" ")[0].charAt(0)}</span>
        <span>{' '}{employee}</span>
      </>
    )
  };

  const EmployeeChip = ({employee}) => {
    return (
      <Chip style={{
        background: getEmployee(employee).color,
        paddingLeft: '5px',
        paddingRight: '5px',
      }} template={content(employee)} />
    )
  };


  // Add an "Assign" button to each list
  const CakeBakingList = ({ order }) => {
    const bakingItems = order.orderItems.reduce((acc, orderItem) => {
      return [...acc, ...orderItem.cakes];
    }, []);

    if (bakingItems.length === 0) {
      return null; // or return some fallback UI
    }

    const label = (cake) => {
      return (
        cake.description
          ? <>Assign:<br />{cake.description}</>
          : <>Assign</>
      );
    };


    return (
      <>
        {/* <Panel header="Cake Items" style={{ marginTop: '10px' }} toggleable> */}
          <h6>Cakes</h6>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            {bakingItems.map((cake, index) => (
              <div key={index} >
                {cake.assignedBaker ? (
                  <button onClick={() => openDialog(order, cake, 'Baker')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px',
                  flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'
                  }}>
                     <Chip className="pl-0 pr-3" template={content(cake.assignedBaker)} style={{marginRight: '3px'}}/>
                    {cake.bakingDate ? formatDay(cake.bakingDate) : 'No date set'}
                   
                  </button>
                ) : (
                  <Button label={label(cake)} onClick={() => openDialog(order, cake, 'Baker')} style={{ marginBottom: '2px' , padding: '3px' }} />
                )}
              </div>
            ))}
          </div>
        {/* </Panel> */}
      </>
    );
  };




  const CakeTopperList = ({ order }) => {
    const topperItems = order.orderItems.reduce((acc, orderItem) => {
      return [...acc, ...orderItem.cakes.flatMap((cake) => cake.toppers)];
    }, []);

    const label = (description) => {
      return (
        <>Assign:<br />{description}</>
      )
    }

    if (topperItems.length === 0) {
      return null; // or return some fallback UI
    }

    return (
      <>
        {/* <Panel header="Cake Items" style={{ marginTop: '10px' }} toggleable> */}
        <h6>Cakes</h6>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            {topperItems.map((topper, index) => (
              <div key={index}>
                {topper.assignedPerson ? (
                  <button onClick={() => openDialog(order, topper, 'Toppers')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px',
                  flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'
                   }}>
                     <b><div>{topper.description}</div></b>
                    <Chip className="pl-0 pr-3" template={content(topper.assignedPerson)} style={{marginRight: '3px'}}/>
                    {topper.dueDate ? formatDay(topper.dueDate) : 'No date set'}
                  </button>
                ) : (
                  <Button label={label(topper.description)} onClick={() => openDialog(order, topper, 'Toppers')} style={{ marginBottom: '2px' , padding: '3px' }} />
                )}
              </div>
            ))}
          </div>
        {/* </Panel> */}
      </>
    );
  };

  const CrumbCoatingList = ({ order }) => {
    const crumbCoatItems = order.orderItems.reduce((acc, orderItem) => {
      return [...acc, ...orderItem.cakes];
    }, []);

    if (crumbCoatItems.length === 0) {
      return null; // or return some fallback UI
    }

    const label = (cake) => {
      return (
        cake.description
          ? <>Assign:<br />{cake.description}</>
          : <>Assign</>
      );
    };



    return (
      <>
        {/* <Panel header="Cake Items" style={{ marginTop: '10px' }} toggleable> */}
        <h6>Cakes</h6>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            {crumbCoatItems.map((cake, index) => (
              <div key={index}>
                {cake.assignedCrumbCoater ? (
                  <button onClick={() => openDialog(order, cake, 'Crumb Coater')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px' ,
                  flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'
                   }}>
                     <Chip className="pl-0 pr-3" template={content(cake.assignedCrumbCoater)} style={{marginRight: '3px'}}/>
                    {cake.crumbCoatDate ? formatDay(cake.crumbCoatDate) : 'No date set'}
                  </button>
                ) : (
                  <Button label={label(cake)} onClick={() => openDialog(order, cake, 'Crumb Coater')} style={{ marginBottom: '2px' , padding: '3px' }} />
                )}
              </div>
            ))}
          </div>
        {/* </Panel> */}
      </>
    );
  };

  const CakeDecoratingList = ({ order }) => {
    const cakeDecoratingItems = order.orderItems.reduce((acc, orderItem) => {
      return [...acc, ...orderItem.cakes];
    }, []);

    if (cakeDecoratingItems.length === 0) {
      return null; // or return some fallback UI
    }

    const label = (cake) => {
      return (
        cake.description
          ? <>Assign:<br />{cake.description}</>
          : <>Assign</>
      );
    };



    return (
      <>
        {/* <Panel header="Cake Items" style={{ marginTop: '10px' }} toggleable> */}
        <h6>Cakes</h6>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            {cakeDecoratingItems.map((cake, index) => (
              <div key={index}>
                {cake.assignedDecorator ? (
                  <button onClick={() => openDialog(order, cake, 'Decorator')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px' ,
                  flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'
                   }}>
                    <Chip className="pl-0 pr-3" template={content(cake.assignedDecorator)} />
                    {cake.decoratingDate ? formatDay(cake.decoratingDate) : 'No date set'}
                  </button>
                ) : (
                  <Button label={label(cake)} onClick={() => openDialog(order, cake, 'Decorator')} style={{ marginBottom: '2px' , padding: '3px' }} />
                )}
              </div>
            ))}
          </div>
        {/* </Panel> */}
      </>
    );
  };

  const CakeDecorationList = ({ order }) => {
    const decoratingItems = order.orderItems.reduce((acc, orderItem) => {
      return [...acc, ...orderItem.cakes.flatMap((cake) => cake.decoratingItems)];
    }, []);

    const label = (description) => {
      return (
        <>Assign:<br />{description}</>
      )
    }

    if (decoratingItems.length === 0) {
      return null;
    }

    return (
      <>
        {/* <Panel header="Cake Items" style={{ marginTop: '10px' }} toggleable> */}
        <h6>Cakes</h6>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            {decoratingItems.map((decorating, index) => (
              <div key={index}>
                {decorating.assignedPerson ? (
                  <button onClick={() => openDialog(order, decorating, 'Details')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px' ,
                  flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'
                   }}>
                    <b><div>{decorating.description}</div></b>
                    <Chip className="pl-0 pr-3" template={content(decorating.assignedPerson)} />
                    {decorating.dueDate ? formatDay(decorating.dueDate) : 'No date set'}
                  </button>
                ) : (
                  <Button label={label(decorating.description)} onClick={() => openDialog(order, decorating, 'Details')} style={{ marginBottom: '2px' , padding: '3px' }} />
                )}
              </div>
            ))}
          </div>
        {/* </Panel> */}
      </>
    );
  };

  const CupcakeBakingList = ({ order }) => {
    const cupcakeItems = order.orderItems.reduce((acc, orderItem) => {
      return [...acc, ...orderItem.cupcakes];
    }, []);

    const label = (cupcake) => {
      return (
        <>
        Assign:<br/>
        <>x{cupcake.quantity} {cupcake.flavor}</>
        </>
      )
    }

    if (cupcakeItems.length === 0) {
      return null;
    }

    return (
      <>
        {/* <Panel header="Cupcake Items" style={{ marginTop: '10px' }} toggleable> */}
        <h6>Cupcakes</h6>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            {cupcakeItems.map((cupcake, index) => (
              <div key={index}>
                {cupcake.assignedBaker ? (
                  <button onClick={() => openDialog(order, cupcake, 'Baker')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px' ,
                  flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'
                   }}>
                    <b><div>x{cupcake.quantity} {cupcake.flavor}</div></b>
                    <Chip className="pl-0 pr-3" template={content(cupcake.assignedBaker)} />
                    {cupcake.bakingDate ? formatDay(cupcake.bakingDate) : 'No date set'}
                    
                  </button>
                ) : (
                  <Button label={label(cupcake)} onClick={() => openDialog(order, cupcake, 'Baker')} severity="success" style={{ marginBottom: '2px' , padding: '3px' }} />
                )}
              </div>
            ))}
          </div>
        {/* </Panel> */}
      </>
    );
  };

  const CupcakeDecoratingList = ({ order }) => {
    const cupcakeDecoratingItems = order.orderItems.reduce((acc, orderItem) => {
      return [...acc, ...orderItem.cupcakes];
    }, []);

    const label = (description) => {
      return (
        description ?
        <>Assign:<br />{description}</>
        : <>Assign</>
      )
    }

    if (cupcakeDecoratingItems.length === 0) {
      return null;
    }

    return (
      <>
        {/* <Panel header="Cupcake Items" style={{ marginTop: '10px' }}  toggleable> */}
        <h6>Cupcakes</h6>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            {cupcakeDecoratingItems.map((cupcake, index) => (
              <div key={index}>
                {cupcake.assignedDecorator ? (
                  <button onClick={() => openDialog(order, cupcake, 'Decorator')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px' ,
                  flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'
                   }}>
                    <b><div>{cupcake.description}</div></b>
                    <Chip className="pl-0 pr-3" template={content(cupcake.assignedDecorator)} />
                    {cupcake.decoratingDate ? formatDay(cupcake.decoratingDate) : 'No date set'}
                    
                  </button>
                ) : (
                  <Button label={label(cupcake.description)} onClick={() => openDialog(order, cupcake, 'Decorator')} severity="success" style={{ marginBottom: '2px' , padding: '3px' }} />
                )}
              </div>
            ))}
          </div>
        {/* </Panel> */}
      </>
    );
  };


  const CakepopBakingList = ({ order }) => {
    const bakingItems = order.orderItems.reduce((acc, orderItem) => {
      return [...acc, ...orderItem.cakePops];
    }, []);

    if (bakingItems.length === 0) {
      return null;
    }

    return (
      <>
        {/* <Panel header="CakePop Items" style={{ marginTop: '10px' }} toggleable> */}
        <h6>Cakepops</h6>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            {bakingItems.map((cakepop, index) => (
              <div key={index} >
                {cakepop.assignedBaker ? (
                  <button onClick={() => openDialog(order, cakepop, 'Baker')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px' ,
                  flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'
                   }}>
                    <b><div>x{cakepop.quantity} {cakepop.flavor}</div></b>
                    <Chip className="pl-0 pr-3" template={content(cakepop.assignedBaker)} />
                    {cakepop.bakingDate ? formatDay(cakepop.bakingDate) : 'No date set'}
                    
                  </button>
                ) : (
                  <Button label="Assign" onClick={() => openDialog(order, cakepop, 'Baker')} severity="danger" style={{ marginBottom: '2px' , padding: '3px' }} />
                )}
              </div>
            ))}
          </div>
        {/* </Panel> */}
      </>
    );
  };

  const CakepopDecoratingList = ({ order }) => {
    const decoratingItems = order.orderItems.reduce((acc, orderItem) => {
      return [...acc, ...orderItem.cakePops];
    }, []);

    const label = (cakepop) => {
      return (
        <>Assign:<br />x{cakepop.quantity} {cakepop.description}</>
      )
    }

    if (decoratingItems.length === 0) {
      return null;
    }

    return (
      <>
        {/* <Panel header="CakePop Items" style={{ marginTop: '10px' }} toggleable> */}
        <h6>Cakepops</h6>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            {decoratingItems.map((cakepop, index) => (
              <div key={index} >
                {cakepop.assignedDecorator ? (
                  <button onClick={() => openDialog(order, cakepop, 'Decorator')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px' ,
                  flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'
                   }}>
                    <b><div>x{cakepop.quantity} {cakepop.description}</div></b>
                    <Chip className="pl-0 pr-3" template={content(cakepop.assignedDecorator)} />
                    {cakepop.decoratingDate ? formatDay(cakepop.decoratingDate) : 'No date set'}
                    
                  </button>
                ) : (
                  <Button label={label(cakepop)} onClick={() => openDialog(order, cakepop, 'Decorator')} severity="danger" style={{ marginBottom: '2px' , padding: '3px' }} />
                )}
              </div>
            ))}
          </div>
        {/* </Panel> */}
      </>
    );
  };

  // Similar pattern for cookies

  const CookieBakingList = ({ order }) => {
    const bakingItems = order.orderItems.reduce((acc, orderItem) => {
      return [...acc, ...orderItem.cookies];
    }, []);

    const label = (cookie) => {
      return (
        <>Assign:<br />x{cookie.quantity} {cookie.flavor} <br />{cookie.shape}</>
      )
    }

    if (bakingItems.length === 0) {
      return null;
    }

    return (
      <>
        {/* <Panel header="Cookie Items" style={{ marginTop: '10px' }} toggleable> */}
        <h6>Cookies</h6>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            {bakingItems.map((cookie, index) => (
              <div key={index} >
                {cookie.assignedBaker ? (
                  <button onClick={() => openDialog(order, cookie, 'Baker')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px' ,
                  flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'
                   }}>
                    <b><div>x{cookie.quantity} {cookie.flavor} - {cookie.shape}</div></b>
                    <Chip className="pl-0 pr-3" template={content(cookie.assignedBaker)} />
                    {/* <EmployeeChip employee={cookie.assignedBaker} /> */}
                    {cookie.bakingDate ? formatDay(cookie.bakingDate) : 'No date set'}
                    
                  </button>
                ) : (
                  <Button label={label(cookie)} onClick={() => openDialog(order, cookie, 'Baker')} severity="warning" style={{ marginBottom: '2px' , padding: '3px' }} />
                )}
              </div>
            ))}
          </div>
        {/* </Panel> */}
      </>
    );
  };

  const CookieDecoratingList = ({ order }) => {
    const decoratingItems = order.orderItems.reduce((acc, orderItem) => {
      return [...acc, ...orderItem.cookies];
    }, []);

    const label = (cookie) => {
      return (
        <>Assign:<br />x{cookie.quantity} {cookie.description + ' ' + cookie.shape}</>
      )
    }

    if (decoratingItems.length === 0) {
      return null;
    }

    return (
      <>
        {/* <Panel header="Cookie Items" style={{ marginTop: '10px' }} toggleable> */}
        <h6>Cookies</h6>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            {decoratingItems.map((cookie, index) => (
              <div key={index} >
                {cookie.assignedDecorator ? (
                  <button onClick={() => openDialog(order, cookie, 'Decorator')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px' ,
                  flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'
                   }}>
                    <b><div>x{cookie.quantity} {cookie.description + ' ' + cookie.shape}</div></b>
                    <Chip className="pl-0 pr-3" template={content(cookie.assignedDecorator)} />
                    {cookie.decoratingDate ? formatDay(cookie.decoratingDate) : 'No date set'}
                    
                  </button>
                ) : (
                  <Button label={label(cookie)} onClick={() => openDialog(order, cookie, 'Decorator')} severity="warning" style={{ marginBottom: '2px' , padding: '3px' }} />
                )}
              </div>
            ))}
          </div>
        {/* </Panel> */}
      </>
    );
  };


  const GeneralItemBakingList = ({ order }) => {
    const bakingItems = order.orderItems.reduce((acc, orderItem) => {
      return [...acc, ...orderItem.generalItems];
    }, []);

    const label = (generalItem) => {
      return (
        <>Assign:<br />x{generalItem.quantity} {generalItem.item} {generalItem.flavor}</>
      )
    }

    if (bakingItems.length === 0) {
      return null;
    }

    return (
      <>
        {/* <Panel header="General Items" style={{ marginTop: '10px' }} toggleable> */}
        <h6>General Items</h6>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            {bakingItems.map((generalItem, index) => (
              <div key={index} >
                {generalItem.assignedBaker ? (
                  <button onClick={() => openDialog(order, generalItem, 'Baker')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', padding: '8px' ,
                  flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'
                    }}>
                    <b><div>x{generalItem.quantity} {generalItem.item} {generalItem.flavor}</div></b>
                    <Chip className="pl-0 pr-3" template={content(generalItem.assignedBaker)} />
                    {generalItem.bakingDate ? formatDay(generalItem.bakingDate) : 'No date set'}

                  </button>
                ) : (
                  <Button label={label(generalItem)} onClick={() => openDialog(order, generalItem, 'Baker')} severity="warning" style={{ marginBottom: '2px' , padding: '3px' }} />
                )}
              </div>
            ))}
          </div>
        {/* </Panel> */}
      </>
    );
  };


  const GeneralItemDecoratingList = ({ order }) => {
      const decoratingItems = order.orderItems.reduce((acc, orderItem) => {
        return [...acc, ...orderItem.generalItems];
      }
      , []);

      const label = (generalItem) => {
        return (
          <>Assign:<br />x{generalItem.quantity} {generalItem.item}/{generalItem.description}</>
        )
      }

      if (decoratingItems.length === 0) {
        return null;
      }

      return (
        <>
          {/* <Panel header="General Items" style={{ marginTop: '10px' }} toggleable> */}
          <h6>General Items</h6>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
              {decoratingItems.map((generalItem, index) => (
                <div key={index} >
                  {generalItem.assignedDecorator ? (
                    <button onClick={() => openDialog(order, generalItem, 'Decorator')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', padding: '8px' ,
                    flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'
                      }}>
                      <b><div>x{generalItem.quantity} {generalItem.item}/{generalItem.description}</div></b>
                      <Chip className="pl-0 pr-3" template={content(generalItem.assignedDecorator)} />
                      {generalItem.decoratingDate ? formatDay(generalItem.decoratingDate) : 'No date set'}

                    </button>
                  ) : (
                    <Button label={label(generalItem)} onClick={() => openDialog(order, generalItem, 'Decorator')} severity="warning" style={{ marginBottom: '2px' , padding: '3px' }} />
                  )}
                </div>
              ))}
            </div>
          {/* </Panel> */}
        </>
      );
    };



  const fulfillmentList = (week) => {
    return orders.reduce((acc, order) => {
      const date = parseISO(order.dueDate);
      if (isSameWeek(date, week, { weekStartsOn: 1 })) {
        acc.push({
          ...order,
          scheduledDateTime: `${formatDayAndDate(order.dueDate)} ${formatTime(order.scheduledTime)}`
        });
      }
      return acc;
    }, []);
  };


  const addressBodyTemplate = (rowData) => {
    let sourceAddress = encodeURIComponent("1150 Empire Central Pl, Dallas TX 75247");
    let destinationAddress = encodeURIComponent(rowData.deliveryAddress);
    let googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${sourceAddress}&destination=${destinationAddress}`;

    return (
      <a href={googleMapsUrl} target="_blank" rel="noreferrer">
        {rowData.deliveryAddress}
      </a>
    );
  };

  const jsonToCSV = (data) => {
    const csvRows = [];
    const headers = Object.keys(data[0]);
    csvRows.push(headers.join(','));

    for (const row of data) {
      const values = headers.map(header => {
        const escaped = ('' + row[header]).replace(/"/g, '\\"');
        return `"${escaped}"`;
      });
      csvRows.push(values.join(','));
    }
    return csvRows.join('\n');
  }


  const columns = [
    {
      field: 'baking', header: 'Baking', body: (rowData) => <>
        <CakeBakingList order={rowData} onClick={(order, cake) => openDialog(order, cake, 'Baker')} />
        <CupcakeBakingList order={rowData} onClick={(order, cupcake) => openDialog(order, cupcake, 'Baker')} />
        <CakepopBakingList order={rowData} onClick={(order, cakepop) => openDialog(order, cakepop, 'Baker')} />
        <CookieBakingList order={rowData} onClick={(order, cookie) => openDialog(order, cookie, 'Baker')} />
        <GeneralItemBakingList order={rowData} onClick={(order, generalItem) => openDialog(order, generalItem, 'Baker')} />
      </>
    },
    {
      field: 'crumbCoating', header: 'Crumb-Coating', body: (rowData) =>
        <CrumbCoatingList order={rowData} onClick={(order, cake) => openDialog(order, cake, 'Crumb Coater')} />
    },
    {
      field: 'decorator', header: 'Decorator', body: (rowData) => <>
        <CakeDecoratingList order={rowData} onClick={(order, cake) => openDialog(order, cake, 'Decorator')} />
        <CupcakeDecoratingList order={rowData} onClick={(order, cupcake) => openDialog(order, cupcake, 'Decorator')} />
        <CakepopDecoratingList order={rowData} onClick={(order, cakepop) => openDialog(order, cakepop, 'Decorator')} />
        <CookieDecoratingList order={rowData} onClick={(order, cookie) => openDialog(order, cookie, 'Decorator')} />
        <GeneralItemDecoratingList order={rowData} onClick={(order, generalItem) => openDialog(order, generalItem, 'Decorator')} />
      </>
    },
    {
      field: 'toppers', header: 'Toppers', body: (rowData) =>
        <CakeTopperList order={rowData} onClick={(order, topper) => openDialog(order, topper, 'Toppers')} />
    },
    {
      field: 'decorationItems', header: 'Decoration Items', body: (rowData) =>
        <CakeDecorationList order={rowData} onClick={(order, decoration) => openDialog(order, decoration, 'Detail')} />
    },
  ];

  const [visibleColumns, setVisibleColumns] = useState(columns);

  const onColumnToggle = (event) => {
    const selectedColumns = event.value;
    const orderedSelectedColumns = columns.filter((col) =>
      selectedColumns.some((sCol) => sCol.field === col.field)
    );

    setVisibleColumns(orderedSelectedColumns);
  };


  // Define a function to render the "weeks" for the DataView
  const weekTemplate = (weekData) => {
    const weekStart = startOfWeek(weekData, { weekStartsOn: 1 });
    const weekEnd = endOfWeek(weekData, { weekStartsOn: 1 });
    
    const { totalOrders, totalEmployeesAssigned } = calculateWeekStats(orders, weekStart, weekEnd);
    
    const startDayFormatted = format(weekStart, 'MM/dd - EEEE');
    const endDayFormatted = format(weekEnd, 'MM/dd - EEEE');
    const header = `${startDayFormatted} - ${endDayFormatted}`;

      //console.log("weekData", weekData);


      return (
        <div
          onClick={() => {setSelectedWeek(weekData)}}
          className={`week-item ${JSON.stringify(selectedWeek) === JSON.stringify(weekData) ? 'selected' : ''}`}
          style={{
            width: '100%',
            borderColor: '#f0f0f0',
            borderWidth: '2px',
            borderStyle: 'solid',
            borderRadius: '15px',
            padding: '8px',
            marginBottom: '2px',
            display: 'flex',
            justifyContent: 'space-between', // similar to .order-item in Orders
            cursor: 'pointer', // similar to .order-item in Orders
          }}
        >
          <div className="week-header">
            <strong>{header}</strong>
          </div>
          <div className="week-summary">
            {/* Insert summary details for the week, e.g. number of orders, employees assigned, etc. */}
            {/* For demonstration purposes, I'll add a placeholder. Update this with your real data. */}
            <div className="week-orders">Total Orders: {totalOrders || 'N/A'}</div>
            {/* <div className="week-employees">Employees Assigned: {totalEmployeesAssigned || 'N/A'}</div> */}
          </div>
        </div>
      );
    };

  // New state variable to hold the selected week
  const [selectedWeek, setSelectedWeek] = useState(null);

  // useEffect(() => {
  //   console.log("selectedWeek", selectedWeek);
  // }, [selectedWeek]);

  const calculateWeekStats = (orders, weekStart, weekEnd) => {
    let totalOrders = 0;
    let employeeSet = new Set();  // Set to store unique employee names
  
    // Loop through all orders
    for (const order of orders) {
      const dueDate = new Date(order.dueDate);
      if (isWithinInterval(dueDate, { start: weekStart, end: weekEnd })) {
        totalOrders++;
        order.orderItems.forEach((item) => {
          // Update this logic according to how your data is structured
          ['cakes', 'cupcakes', 'cakePops', 'cookies', 'generalItems'].forEach((productType) => {
            item[productType].forEach((product) => {
              if (product.assignedBaker) employeeSet.add(product.assignedBaker);
              if (product.assignedCrumbCoater) employeeSet.add(product.assignedCrumbCoater);
              if (product.assignedDecorator) employeeSet.add(product.assignedDecorator);
              if (product.assignedPerson) employeeSet.add(product.assignedPerson);
            });
          });
        });
      }
    }
  
    const totalEmployeesAssigned = employeeSet.size;  // Total number of unique employees
  
    return { totalOrders, totalEmployeesAssigned };
  };
  
  const updateOrder = (orderToUpdate) => {
    OrderService.updateOrder(orderToUpdate._id, orderToUpdate)
    .then((response) => {
      console.log('After Save:', response); // Display the response after the save operation is complete
      refreshOrders();
    })
    .catch((error) => {
      console.error('Error updating order:', error);
      refreshOrders();
    });
    
  };

  
//   const [editedRow, setEditedRow] = useState(null);
//   const orderIdEditor = (props) => {
//     return (
//         <div style={{ display: 'flex', alignItems: 'center' }}>
//             <InputText 
//                 type="text"
//                 value={props.rowData.orderId} 
//                 onChange={(e) => setEditedRow({ ...props.rowData, orderID: e.target.value })}
//             />
//             <button 
//                 onClick={() => {
//                     updateOrder(editedRow); // Assuming you have the updateOrder function from your previous code
//                     setEditedRow(null);
//                 }}
//                 style={{ marginLeft: '5px' }}>
//                 &#10003; {/* Checkmark symbol */}
//             </button>
//             {/* <button 
//                 onClick={() => setEditedRow(null)}
//                 style={{ marginLeft: '5px' }}>
//                 &#10007; 
//             </button> */}
//         </div>
//     );
// };


const [filters, setFilters] = useState(null);
const [globalFilterValue, setGlobalFilterValue] = useState('');

useEffect(() => {
  initFilters();
}, []);

const clearFilter = () => {
  initFilters();
};

const onGlobalFilterChange = (e) => {
  const value = e.target.value;
  let _filters = { ...filters };

  _filters['global'].value = value;

  setFilters(_filters);
  setGlobalFilterValue(value);
};

const initFilters = () => {
  let initialFilters = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    orderID: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    type: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'customer.name': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'customer.phone': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'customer.email': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    description: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    deliveryAddress: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
  };

  setFilters(initialFilters);

  setGlobalFilterValue('');
};

const renderHeader = () => {
  return (
      <div className="flex justify-content-between">
          <Button type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} />
          <span className="p-input-icon-left">
              <i className="pi pi-search" />
              <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
          </span>
      </div>
  );
};


  return (
    <div style={{ fontFamily: 'Arial, sans-serif' }}>
      <Dialog header="Assign Employee" visible={displayDialog} onHide={() => { setDisplayDialog(false); setNote(''); setDescription(''); }} modal={true} footer={
        <>
          <Button
            label="Assign"
            onClick={() => {
              if (selectedItem && selectedItem.orderId) {
                const orderToUpdate = orders.find((order) => order._id === selectedItem.orderId); // find the order to be updated
                if (orderToUpdate) {
                  const updatedOrder = JSON.parse(JSON.stringify(orderToUpdate)); // deep copy of the order

                  // Find the corresponding item and update it
                  updatedOrder.orderItems.forEach((orderItem) => {
                    // Handle cakes
                    orderItem.cakes.forEach((cake) => {
                      if (cake._id === selectedItem._id) {
                        switch (selectedItem.roleType) {
                          case 'Baker':
                            cake.assignedBaker = assignee;
                            cake.bakingDate = new Date(dueDate);
                            cake.bakingNotes = note;
                            break;
                          case 'Crumb Coater':
                            cake.assignedCrumbCoater = assignee;
                            cake.crumbCoatDate = new Date(dueDate);
                            cake.crumbcoatingNote = note;
                            break;
                          case 'Decorator':
                            cake.assignedDecorator = assignee;
                            cake.decoratingDate = new Date(dueDate);
                            cake.decoratingNotes = note;
                            break;
                          default:
                            break;
                        }
                      }

                      // Handle toppers
                      cake.toppers.forEach((topperItem) => {
                        if (topperItem._id === selectedItem._id && selectedItem.roleType === 'Toppers') {
                          topperItem.assignedPerson = assignee;
                          topperItem.dueDate = new Date(dueDate);
                          topperItem.note = note;
                          topperItem.description = description;
                        }
                      });

                      // Handle decorating items
                      cake.decoratingItems.forEach((decoratingItem) => {
                        if (decoratingItem._id === selectedItem._id && selectedItem.roleType === 'Details') {
                          decoratingItem.assignedPerson = assignee;
                          decoratingItem.dueDate = new Date(dueDate);
                          decoratingItem.notes = note;
                          decoratingItem.description = description;
                        }
                      });
                    });

                    // Handle cupcakes
                    orderItem.cupcakes.forEach((cupcake) => {
                      if (cupcake._id === selectedItem._id) {
                        switch (selectedItem.roleType) {
                          case 'Baker':
                            cupcake.assignedBaker = assignee;
                            cupcake.bakingDate = new Date(dueDate);
                            cupcake.bakingNotes = note;
                            break;
                          case 'Decorator':
                            cupcake.assignedDecorator = assignee;
                            cupcake.decoratingDate = new Date(dueDate);
                            cupcake.decoratingNotes = note;
                            break;
                          default:
                            break;
                        }
                      }
                    });

                    // Handle cakePops
                    orderItem.cakePops.forEach((cakepop) => {
                      if (cakepop._id === selectedItem._id) {
                        switch (selectedItem.roleType) {
                          case 'Baker':
                            cakepop.assignedBaker = assignee;
                            cakepop.bakingDate = new Date(dueDate);
                            cakepop.bakingNotes = note;
                            break;
                          case 'Decorator':
                            cakepop.assignedDecorator = assignee;
                            cakepop.decoratingDate = new Date(dueDate);
                            cakepop.decoratingNotes = note;
                            break;
                          default:
                            break;
                        }
                      }
                    });

                    // Handle cookies
                    orderItem.cookies.forEach((cookie) => {
                      if (cookie._id === selectedItem._id) {
                        switch (selectedItem.roleType) {
                          case 'Baker':
                            cookie.assignedBaker = assignee;
                            cookie.bakingDate = new Date(dueDate);
                            cookie.bakingNotes = note;
                            break;
                          case 'Decorator':
                            cookie.assignedDecorator = assignee;
                            cookie.decoratingDate = new Date(dueDate);
                            cookie.decoratingNotes = note;
                            break;
                          default:
                            break;
                        }
                      }
                    });

                    orderItem.generalItems.forEach((generalItem) => {
                      if (generalItem._id === selectedItem._id) {
                        switch (selectedItem.roleType) {
                          case 'Baker':
                            generalItem.assignedBaker = assignee;
                            generalItem.bakingDate = new Date(dueDate);
                            generalItem.bakingNotes = note;
                            break;
                          case 'Decorator':
                            generalItem.assignedDecorator = assignee;
                            generalItem.decoratingDate = new Date(dueDate);
                            generalItem.decoratingNotes = note;
                            break;
                          default:
                            break;
                        }
                      }
                    });
                  });

                  


                  console.log('Before Save:', orderToUpdate); // Display the order details before save
                  console.log('Updated Data:', updatedOrder); // Display the order details that are to be saved

                  OrderService.updateOrder(updatedOrder._id, updatedOrder)
                    .then((response) => {
                      console.log('After Save:', response); // Display the response after the save operation is complete
                      refreshOrders();
                    })
                    .catch((error) => {
                      console.error('Error updating order:', error);
                      refreshOrders();
                    });
                }
              }

              setDisplayDialog(false);
              setNote('');
              setDescription('');
            }}
          />
          <Button label="Cancel" onClick={() => { setDisplayDialog(false); setNote(''); setDescription(''); }} className="p-button-text" />
        </>
      }>
        {description && (
          <>
            <h3>Description:</h3>
            <InputText value={description} onChange={(e) => setDescription(e.target.value)} />
          </>
        )}
        <h3>Select Employee:</h3>
        <Dropdown value={assignee} options={getEmployeesByRole('Baker')} onChange={(e) => setAssignee(e.value)} placeholder="Select an Employee" optionLabel="label" />
        <h3>Select Date:</h3>
        <Calendar value={dueDate} onChange={(e) => setDueDate(e.value)} />
        <h3>Note:</h3>
        <InputTextarea value={note} onChange={(e) => setNote(e.target.value)} rows={5} cols={30} autoResize />
        {console.log('Note:', note)}
      </Dialog>
      <div style={{ display: 'flex', flexDirection: 'row', height: 'calc(100vh - 100px)', overflow: 'hidden' }}>
      {/* DataView Side */}
      <div style={{ width: '350px', padding: '1em', borderRight: '1px solid #ccc', background: '#f9f9f9', overflowY: 'auto', flexShrink: 0 }}>
          <h5 style={{ marginBottom: '10px' }}>Order Filters</h5>
        <Calendar value={dateRange.start} onChange={(e) => setDateRange({ ...dateRange, start: e.value })} />
        <Calendar value={dateRange.end} onChange={(e) => setDateRange({ ...dateRange, end: e.value })} />
        {/* <Button label="Sort Asc/Desc" onClick={() => setSorted(!sorted)} />
        <Button label="Export to CSV" className="p-button-success" style={{ marginLeft: '10px' }}>
          {csvReport && <CSVLink {...csvReport}></CSVLink>}
        </Button>
        <MultiSelect value={visibleColumns} options={columns} optionLabel={("header")} onChange={onColumnToggle} className="w-full sm:w-20rem" display="chip" />
        <Button label="Toggle Table Height" onClick={() => setScrollHeight(scrollHeight === '500px' ? '1000px' : '500px')} /> */}

        {/* DataView Side */}
        <div style={{ flex: '1', padding: '1em', borderRight: '1px solid #ccc', background: '#f9f9f9', 
       }}>
          <h3>Weeks</h3>
          <DataView
            value={sortAndFilterOrders()}
            itemTemplate={weekTemplate}
            layout="list"
            rows={5}
          />
        </div>
          </div>
           {/* Week Detail Side */}
      <div style={{ flex: '4', height: '100%', flexGrow: 1, overflowY: 'hidden', overflowX: 'auto', padding: '0 10px'}}>
          <div style={{
            display: 'flex', flexDirection: 'row', height: '100%',
            // border: '1px solid #ccc', 
            // borderRadius: '8px', 
            overflowY: 'auto',
                    
          }}>
            {selectedWeek ? (
            <>

                  {fulfillmentList(selectedWeek).length > 0 && (
                    <DataTable
                      value={fulfillmentList(selectedWeek)}
                      filters={filters}
                      globalFilterFields={['orderID', 'type', 'customer.name', 'baking']}
                      size="small"
                      sortMode="multiple"
                      sortField="orderID"
                      style={{ maxWidth: '100%', width: '100%', flex: '1', 
                    }}
                      header={
                        <div className="flex flex-wrap align-items-center justify-content-between gap-2">
                          <span className="text-xl text-900 font-bold">Orders</span>
                          {renderHeader()}
                        </div>
                      }
                      showGridlines 
                      stripedRows
                      columntoggleicon="pi pi-cog"
                      columnResizeMode="expand"
                      resizableColumns
                      scrollable
                      scrollHeight={scrollHeight}
                      //editMode="cell"
                      // onRowEditInit={e => setEditedRow(e.data)}
                      // onRowEditSave={e => {
                      //   console.log("editedRow", editedRow);
                      //   //updateOrder(editedRow);
                      //   setEditedRow(null);
                      // }}
                      // onRowEditCancel={e => setEditedRow(null)}
                    >
                      <Column 
                          field="orderID" 
                          header="Order ID" 
                          sortable
                          // editor={(props) => orderIdEditor(props)}
                          // editorValidator={(e) => {
                          //   // You can add validation logic here if needed
                          //   return true; 
                          // }}
                        
                        />
                      <Column field="type" header="Type" sortable></Column>
                      <Column field="scheduledDateTime" header="Scheduled DateTime" sortable
                      //split "Month day, year" and "Day Time AM/PM" into seperate rows
                        body={(rowData) => (
                          <div>
                            <div><strong>{rowData.scheduledDateTime.split('-')[0]}</strong></div>
                            <div>{rowData.scheduledDateTime.split('-')[1]}</div>
                          </div>
                        )}
                      ></Column>
                      <Column field="customer.name" header="Customer"
                        body={(rowData) => (
                          <div>
                            <div><strong>{rowData.name}</strong></div>
                            <div>{rowData.customer.name}</div>
                            <div>{rowData.customer.phone}</div>
                            <div>{rowData.customer.email}</div>
                          </div>
                        )}
                      
                      ></Column>
                      {/* <Column field="name" header="Order"></Column> */}
                      {visibleColumns.map((col) => (
                        <Column key={col.field} field={col.field} header={col.header} body={col.body} style={{ textAlign: 'left', verticalAlign: 'top' }} />
                      ))}
                      {/*<Column field="deliveryAddress" header="Delivery Address" body={addressBodyTemplate}></Column>*/}
                    </DataTable>
                  )}
             </>
            )
            : (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                backgroundColor: '#f7f7f7',
                borderRadius: '8px',
                textAlign: 'center',
                maxWidth: '100%',
                width: '100%',
              }}>
                <h3>Please select a week</h3>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeeklySummary;

// import React, { useEffect, useState } from 'react';
// import { Panel } from 'primereact/panel';
// import { Button } from 'primereact/button';
// import { Calendar } from 'primereact/calendar';
// import { OrderService } from './service/OrderService';
// import { DataTable } from 'primereact/datatable';
// import { Column } from 'primereact/column';
// import { add, startOfWeek, endOfWeek, eachWeekOfInterval, formatISO, parseISO, isSameWeek, set } from 'date-fns';
// import { formatDayAndDate, formatTime, formatDay } from '../utils.js';
// import { CSVLink } from "react-csv";
// import { MultiSelect } from 'primereact/multiselect';
// import { Dialog } from 'primereact/dialog';
// import { Dropdown } from 'primereact/dropdown';
// import { InputTextarea } from 'primereact/inputtextarea';
// import { InputText } from 'primereact/inputtext';
// import { Chip } from 'primereact/chip';

// const WeeklySummary = () => {
//   const defaultDateRange = {
//     start: new Date().toISOString(),
//     end: add(new Date(), { days: 90 }).toISOString()
//   };

//   const [orders, setOrders] = useState([]);
//   const [sorted, setSorted] = useState(false);
//   const [csvReport, setCsvReport] = useState(null);
//   const [employees, setEmployees] = useState([]);
//   const [displayDialog, setDisplayDialog] = useState(false);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [assignee, setAssignee] = useState(null);
//   const [dueDate, setDueDate] = useState(null);
//   const [note, setNote] = useState("");
//   const [description, setDescription] = useState("");
//   const [scrollHeight, setScrollHeight] = useState('1000px');

//   const storedDateRange = localStorage.getItem('dateRange_');
//   const initialDateRange = storedDateRange
//     ? JSON.parse(storedDateRange)
//     : defaultDateRange;

//   const [dateRange, setDateRange] = useState({
//     start: new Date(initialDateRange.start),
//     end: new Date(initialDateRange.end)
//   });

//   useEffect(() => {
//     OrderService.getOrders().then(data => {
//       console.log("Orders: ", data);  // Log the orders data
//       setOrders(data);

//       const csvReport = {
//         data: jsonToCSV(data),
//         headers: Object.keys(data[0]),
//         filename: 'OrderReport.csv'
//       }

//       setCsvReport(csvReport);
//     });
//     OrderService.getEmployees().then(setEmployees);
//   }, []);

//   async function refreshOrders() {
//     OrderService.getOrders().then(data => {
//       setOrders(data);
//     });
//   };

//   const getEmployeesByRole = (role) => {
//     return employees.filter(employee => employee.roles.includes(role)).map(employee => ({ label: employee.name, value: employee.name }));
//   };


//   useEffect(() => {
//     const stringifiedDateRange = {
//       start: dateRange.start.toISOString(),
//       end: dateRange.end.toISOString()
//     };
//     localStorage.setItem('dateRange_', JSON.stringify(stringifiedDateRange));
//   }, [dateRange]);

//   const sortAndFilterOrders = () => {
//     const weeks = eachWeekOfInterval({
//       start: dateRange.start,
//       end: dateRange.end
//     }, { weekStartsOn: 0 });

//     if(sorted) {
//       return weeks.sort((a, b) => b - a); // For descending order
//     }
//     return weeks.sort((a, b) => a - b); // For ascending order
// };

//   const dueList = (week) => {
//     return orders.filter((order) => {
//         const date = parseISO(order.dueDate);
//         return isSameWeek(date, week, { weekStartsOn: 0 });
//     });
//   };



//   // Create a function to open the dialog
//   const openDialog = (order, item, roleType) => {
//     setSelectedItem({
//       orderId: order._id,
//       _id: item._id,
//       roleType
//     });
//     switch (roleType) {
//       case 'Baker':
//         setAssignee(item.assignedBaker);
//         setDueDate(item.bakingDate ? new Date(item.bakingDate) : null);
//         setNote(item.bakingNotes);
//         break;
//       case 'Toppers':
//       case 'Details':
//         setAssignee(item.assignedPerson);
//         setDueDate(item.dueDate ? new Date(item.dueDate) : null);
//         setNote(item.note);
//         setDescription(item.description);
//         break;  // added break statement here
//       case 'Decorator':
//         setAssignee(item.assignedDecorator);
//         setDueDate(item.decoratingDate ? new Date(item.decoratingDate) : null);
//         setNote(item.decoratingNotes);
//         break;
//       case 'Crumb Coater':
//         setAssignee(item.assignedCrumbCoater);
//         setDueDate(item.crumbCoatDate ? new Date(item.crumbCoatDate) : null);
//         setNote(item.crumbCoatNote);
//         break;
//       default:
//         break;
//     }
  
//     setDisplayDialog(true);
//   };

//   const content = (employee) => {
//     return (
//     <>
//         <span className="bg-primary border-circle w-2rem h-2rem flex align-items-center justify-content-center">{employee.split(" ")[0].charAt(0)}</span>
//         <span className="ml-2 font-medium">{employee}</span>
//     </>
//   )};


//   // Add an "Assign" button to each list
//   const CakeBakingList = ({ order }) => {
//     const bakingItems = order.orderItems.reduce((acc, orderItem) => {
//       return [...acc, ...orderItem.cakes];
//     }, []);

//     if(bakingItems.length === 0) {
//       return null; // or return some fallback UI
//     }

//     const label = (cake) => {
//       return (
//         cake.description
//           ? <>Assign:<br/>{cake.description}</>
//           : <>Assign</>
//       );
//     };
    

//     return (
//       <>
//       <Panel header="Cake Items" style={{marginTop: '10px'}} toggleable>
//       <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
//         {bakingItems.map((cake, index) => (
//           <div key={index} >
//             {cake.assignedBaker ? (
//               <button onClick={() => openDialog(order, cake, 'Baker')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px'}}>
//                 <div>{cake.bakingDate ? formatDay(cake.bakingDate) : 'No date set'}</div>
//                 <Chip className="pl-0 pr-3" template={content(cake.assignedBaker)} />
//               </button>
//             ) : (
//               <Button label={label(cake)} onClick={() => openDialog(order, cake, 'Baker')} style={{marginBottom: '2px'}}/>
//             )}
//           </div>
//         ))}
//       </div>
//       </Panel>
//       </>
//     );
//   };




//   const CakeTopperList = ({ order }) => {
//     const topperItems = order.orderItems.reduce((acc, orderItem) => {
//       return [...acc, ...orderItem.cakes.flatMap((cake) => cake.toppers)];
//     }, []);

//     const label = (description) => {
//       return (
//         <>Assign:<br/>{description}</>
//       )
//     }

//     if(topperItems.length === 0) {
//       return null; // or return some fallback UI
//     }
  
//     return (
//       <>
//       <Panel header="Cake Items" style={{marginTop: '10px'}} toggleable>
//       <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
//         {topperItems.map((topper, index) => (
//           <div key={index}>
//             {topper.assignedPerson ? (
//               <button onClick={() => openDialog(order, topper, 'Toppers')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px'}}>
//                 <b><div>{topper.description}</div></b>
//                 <div>{topper.dueDate ? formatDay(topper.dueDate) : 'No date set'}</div>
//                 <Chip className="pl-0 pr-3" template={content(topper.assignedPerson)} />
                
//               </button>
//             ) : (
//               <Button label={label(topper.description)} onClick={() => openDialog(order, topper, 'Toppers')} style={{marginBottom: '2px'}}/>
//             )}
//           </div>
//         ))}
//         </div>
//       </Panel>
//       </>
//     );
//   };
  
//   const CrumbCoatingList = ({ order }) => {
//     const crumbCoatItems = order.orderItems.reduce((acc, orderItem) => {
//       return [...acc, ...orderItem.cakes];
//     }, []);

//     if(crumbCoatItems.length === 0) {
//       return null; // or return some fallback UI
//     }

//     const label = (cake) => {
//       return (
//         cake.description
//           ? <>Assign:<br/>{cake.description}</>
//           : <>Assign</>
//       );
//     };
    
    
  
//     return (
//       <>
//       <Panel header="Cake Items" style={{marginTop: '10px'}} toggleable>
//       <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
//         {crumbCoatItems.map((cake, index) => (
//           <div key={index}>
//             {cake.assignedCrumbCoater ? (
//               <button onClick={() => openDialog(order, cake, 'Crumb Coater')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px'}}>
//                 <div>{cake.crumbCoatDate ? formatDay(cake.crumbCoatDate) : 'No date set'}</div>
//                 <Chip className="pl-0 pr-3" template={content(cake.assignedCrumbCoater)} />
//               </button>
//             ) : (
//               <Button label={label(cake)} onClick={() => openDialog(order, cake, 'Crumb Coater')} style={{marginBottom: '2px'}}/>
//             )}
//           </div>
//         ))}
//         </div>
//       </Panel>
//       </>
//     );
//   };
  
//   const CakeDecoratingList = ({ order }) => {
//     const cakeDecoratingItems = order.orderItems.reduce((acc, orderItem) => {
//       return [...acc, ...orderItem.cakes];
//     }, []);

//     if(cakeDecoratingItems.length === 0) {
//       return null; // or return some fallback UI
//     }

//     const label = (cake) => {
//       return (
//         cake.description
//           ? <>Assign:<br/>{cake.description}</>
//           : <>Assign</>
//       );
//     };
    
    
  
//     return (
//       <>
//       <Panel header="Cake Items" style={{marginTop: '10px'}} toggleable>
//       <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
//         {cakeDecoratingItems.map((cake, index) => (
//           <div key={index}>
//             {cake.assignedDecorator ? (
//               <button onClick={() => openDialog(order, cake, 'Decorator')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px'}}>
//                 <div>{cake.decoratingDate ? formatDay(cake.decoratingDate) : 'No date set'}</div>
//                 <Chip className="pl-0 pr-3" template={content(cake.assignedDecorator)} />
//               </button>
//             ) : (
//               <Button label={label(cake)} onClick={() => openDialog(order, cake, 'Decorator')} style={{marginBottom: '2px'}} />
//             )}
//           </div>
//         ))}
//         </div>
//       </Panel>
//       </>
//     );
//   };
  
//   const CakeDecorationList = ({ order }) => {
//     const decoratingItems = order.orderItems.reduce((acc, orderItem) => {
//       return [...acc, ...orderItem.cakes.flatMap((cake) => cake.decoratingItems)];
//     }, []);

//     const label = (description) => {
//       return (
//         <>Assign:<br/>{description}</>
//       )
//     }

//     if(decoratingItems.length === 0) {
//       return null; 
//     }
  
//     return (
//       <>
//       <Panel header="Cake Items" style={{marginTop: '10px'}} toggleable>
//       <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
//         {decoratingItems.map((decorating, index) => (
//           <div key={index}>
//             {decorating.assignedPerson ? (
//               <button onClick={() => openDialog(order, decorating, 'Details')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px'}}>
//                 <b><div>{decorating.description}</div></b>
//                 <div>{decorating.dueDate ? formatDay(decorating.dueDate) : 'No date set'}</div>
//                 <Chip className="pl-0 pr-3" template={content(decorating.assignedPerson)} />
//               </button>
//             ) : (
//               <Button label={label(decorating.description)}onClick={() => openDialog(order, decorating, 'Details')} style={{marginBottom: '2px'}}/>
//             )}
//           </div>
//         ))}
//         </div>
//       </Panel>
//       </>
//     );
//   };
  
//   const CupcakeBakingList = ({ order }) => {
//     const cupcakeItems = order.orderItems.reduce((acc, orderItem) => {
//       return [...acc, ...orderItem.cupcakes];
//     }, []);

//     const label = (cupcake) => {
//       return (
//         <>x{cupcake.quantity} {cupcake.flavor}</>
//       )
//     }

//     if(cupcakeItems.length === 0) {
//       return null; 
//     }
  
//     return (
//       <>
//       <Panel header="Cupcake Items" style={{marginTop: '10px'}} toggleable>
//       <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
//         {cupcakeItems.map((cupcake, index) => (
//           <div key={index}>
//             {cupcake.assignedBaker ? (
//               <button onClick={() => openDialog(order, cupcake, 'Baker')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px'}}>
//                 <b><div>x{cupcake.quantity} {cupcake.flavor}</div></b>
//                 <div>{cupcake.bakingDate ? formatDay(cupcake.bakingDate) : 'No date set'}</div>
//                 <Chip className="pl-0 pr-3" template={content(cupcake.assignedBaker)} />
//               </button>
//             ) : (
//               <Button label={label(cupcake)} onClick={() => openDialog(order, cupcake, 'Baker')} severity="help" style={{marginBottom: '2px'}}/>
//             )}
//           </div>
//         ))}
//         </div>
//         </Panel>
//       </>
//     );
//   }; 
  
//   const CupcakeDecoratingList = ({ order }) => {
//     const cupcakeDecoratingItems = order.orderItems.reduce((acc, orderItem) => {
//       return [...acc, ...orderItem.cupcakes];
//     }, []);

//     const label = (description) => {
//       return (
//         <>Assign:<br/>{description}</>
//       )
//     }

//     if(cupcakeDecoratingItems.length === 0) {
//       return null; 
//     }
  
//     return (
//       <>
//       <Panel header="Cupcake Items" style={{marginTop: '10px'}} /*collapsed*/ toggleable>
//       <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
//         {cupcakeDecoratingItems.map((cupcake, index) => (
//           <div key={index}>
//             {cupcake.assignedDecorator ? (
//               <button onClick={() => openDialog(order, cupcake, 'Decorator')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px'}}>
//                 <b><div>{cupcake.description}</div></b>
//                 <div>{cupcake.decoratingDate ? formatDay(cupcake.decoratingDate) : 'No date set'}</div>
//                 <Chip className="pl-0 pr-3" template={content(cupcake.assignedDecorator)} />
//               </button>
//             ) : (
//               <Button label={label(cupcake.description)} onClick={() => openDialog(order, cupcake, 'Decorator')} severity="help" style={{marginBottom: '2px'}}/>
//             )}
//           </div>
//         ))}
//         </div>
//         </Panel>
//       </>
//     );
//   };


//   const CakepopBakingList = ({ order }) => {
//     const bakingItems = order.orderItems.reduce((acc, orderItem) => {
//       return [...acc, ...orderItem.cakePops];
//     }, []);

//     if(bakingItems.length === 0) {
//       return null;
//     }
  
//     return (
//       <>
//       <Panel header="CakePop Items" style={{marginTop: '10px'}} toggleable>
//       <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
//         {bakingItems.map((cakepop, index) => (
//           <div key={index} >
//             {cakepop.assignedBaker ? (
//               <button onClick={() => openDialog(order, cakepop, 'Baker')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px'}}>
//                 <div>{cakepop.bakingDate ? formatDay(cakepop.bakingDate) : 'No date set'}</div>
//                 <Chip className="pl-0 pr-3" template={content(cakepop.assignedBaker)} />
//               </button>
//             ) : (
//               <Button label="Assign" onClick={() => openDialog(order, cakepop, 'Baker')} severity="secondary" style={{marginBottom: '2px'}}/>
//             )}
//           </div>
//         ))}
//         </div>
//       </Panel>
//       </>
//     );
//   };
  
//   const CakepopDecoratingList = ({ order }) => {
//     const decoratingItems = order.orderItems.reduce((acc, orderItem) => {
//       return [...acc, ...orderItem.cakePops];
//     }, []);

//     const label = (cakepop) => {
//       return (
//         <>Assign:<br/>x{cakepop.quantity} {cakepop.description}</>
//       )
//     }

//     if(decoratingItems.length === 0) {
//       return null;
//     }
  
//     return (
//       <>
//       <Panel header="CakePop Items" style={{marginTop: '10px'}} toggleable>
//       <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
//         {decoratingItems.map((cakepop, index) => (
//           <div key={index} >
//             {cakepop.assignedDecorator ? (
//               <button onClick={() => openDialog(order, cakepop, 'Decorator')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px'}}>
//                 <b><div>x{cakepop.quantity} {cakepop.description}</div></b>
//                 <div>Date: {cakepop.decoratingDate ? formatDay(cakepop.decoratingDate) : 'No date set'}</div>
//                 <Chip className="pl-0 pr-3" template={content(cakepop.assignedDecorator)} />
//               </button>
//             ) : (
//               <Button label={label(cakepop)} onClick={() => openDialog(order, cakepop, 'Decorator')} severity="secondary" style={{marginBottom: '2px'}}/>
//             )}
//           </div>
//         ))}
//         </div>
//       </Panel>
//       </>
//     );
//   };
  
//   // Similar pattern for cookies
  
//   const CookieBakingList = ({ order }) => {
//     const bakingItems = order.orderItems.reduce((acc, orderItem) => {
//       return [...acc, ...orderItem.cookies];
//     }, []);

//     const label = (cookie) => {
//       return (
//         <>Assign:<br/>x{cookie.quantity} {cookie.flavor} <br/>{cookie.shape}</>
//       )
//     }

//     if(bakingItems.length === 0) {
//       return null;
//     }
  
//     return (
//       <>
//       <Panel header="Cookie Items" style={{marginTop: '10px'}} toggleable>
//       <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
//         {bakingItems.map((cookie, index) => (
//           <div key={index} >
//             {cookie.assignedBaker ? (
//               <button onClick={() => openDialog(order, cookie, 'Baker')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px'}}>
//                 <b><div>x{cookie.quantity} {cookie.flavor} - {cookie.shape}</div></b>
//                 <div>{cookie.bakingDate ? formatDay(cookie.bakingDate) : 'No date set'}</div>
//                 <Chip className="pl-0 pr-3" template={content(cookie.assignedBaker)} />
//               </button>
//             ) : (
//               <Button label={label(cookie)} onClick={() => openDialog(order, cookie, 'Baker')} severity="warning" style={{marginBottom: '2px'}}/>
//             )}
//           </div>
//         ))}
//         </div>
//       </Panel>
//       </>
//     );
//   };
  
//   const CookieDecoratingList = ({ order }) => {
//     const decoratingItems = order.orderItems.reduce((acc, orderItem) => {
//       return [...acc, ...orderItem.cookies];
//     }, []);

//     const label = (cookie) => {
//       return (
//         <>Assign:<br/>x{cookie.quantity} {cookie.description + ' ' + cookie.shape}</>
//       )
//     }

//     if(decoratingItems.length === 0) {
//       return null;
//     }
  
//     return (
//       <>
//       <Panel header="Cookie Items" style={{marginTop: '10px'}} toggleable>
//       <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
//         {decoratingItems.map((cookie, index) => (
//           <div key={index} >
//             {cookie.assignedDecorator ? (
//               <button onClick={() => openDialog(order, cookie, 'Decorator')} style={{ background: '#f7f7f7', border: 'none', cursor: 'pointer', borderRadius: '10px', textAlign: 'left', marginBottom: '3px', marginRight: '3px', padding: '8px'}}>
//                 <b><div>x{cookie.quantity} {cookie.description + ' ' + cookie.shape}</div></b>
//                 <div>{cookie.decoratingDate ? formatDay(cookie.decoratingDate) : 'No date set'}</div>
//                 <Chip className="pl-0 pr-3" template={content(cookie.assignedDecorator)} />
//               </button>
//             ) : (
//               <Button label={label(cookie)} onClick={() => openDialog(order, cookie, 'Decorator')} severity="warning" style={{marginBottom: '2px'}}/>
//             )}
//           </div>
//         ))}
//         </div>
//       </Panel>
//       </>
//     );
//   };



//   const fulfillmentList = (week) => {
//     return orders.reduce((acc, order) => {
//       const date = parseISO(order.dueDate);
//       if (isSameWeek(date, week, { weekStartsOn: 0 })) {
//         acc.push({
//           ...order,
//           scheduledDateTime: `${formatDayAndDate(order.dueDate)} ${formatTime(order.scheduledTime)}`
//         });
//       }
//       return acc;
//     }, []);
//   };


//   const addressBodyTemplate = (rowData) => {
//     let sourceAddress = encodeURIComponent("1150 Empire Central Pl, Dallas TX 75247");
//     let destinationAddress = encodeURIComponent(rowData.deliveryAddress);
//     let googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${sourceAddress}&destination=${destinationAddress}`;

//     return (
//       <a href={googleMapsUrl} target="_blank" rel="noreferrer">
//         {rowData.deliveryAddress}
//       </a>
//     );
//   };

//   const jsonToCSV = (data) => {
//     const csvRows = [];
//     const headers = Object.keys(data[0]);
//     csvRows.push(headers.join(','));

//     for (const row of data) {
//       const values = headers.map(header => {
//         const escaped = ('' + row[header]).replace(/"/g, '\\"');
//         return `"${escaped}"`;
//       });
//       csvRows.push(values.join(','));
//     }
//     return csvRows.join('\n');
//   }


//   const columns = [
//     { field: 'baking', header: 'Baking', body: (rowData) => <>
//                             <CakeBakingList order={rowData} onClick={(order, cake) => openDialog(order, cake, 'Baker')} />
//                             <CupcakeBakingList order={rowData} onClick={(order, cupcake) => openDialog(order, cupcake, 'Baker')} />
//                             <CakepopBakingList order={rowData} onClick={(order, cakepop) => openDialog(order, cakepop, 'Baker')} />
//                             <CookieBakingList order={rowData} onClick={(order, cookie) => openDialog(order, cookie, 'Baker')} />
//                             </> },
//     { field: 'crumbCoating', header: 'Crumb-Coating', body: (rowData) =>
//                             <CrumbCoatingList order={rowData} onClick={(order, cake) => openDialog(order, cake, 'Crumb Coater')} />
//                           },
//     { field: 'decorator', header: 'Decorator', body: (rowData) => <>
//                             <CakeDecoratingList order={rowData} onClick={(order, cake) => openDialog(order, cake, 'Decorator')} />
//                             <CupcakeDecoratingList order={rowData} onClick={(order, cupcake) => openDialog(order, cupcake, 'Decorator')} />
//                             <CakepopDecoratingList order={rowData} onClick={(order, cakepop) => openDialog(order, cakepop, 'Decorator')} /> 
//                             <CookieDecoratingList order={rowData} onClick={(order, cookie) => openDialog(order, cookie, 'Decorator')} />
//                             </> },
//     { field: 'toppers', header: 'Toppers', body: (rowData) =>
//                             <CakeTopperList order={rowData} onClick={(order, topper) => openDialog(order, topper, 'Toppers')} />
//                           },
//     { field: 'decorationItems', header: 'Decoration Items', body: (rowData) =>
//                             <CakeDecorationList order={rowData} onClick={(order, decoration) => openDialog(order, decoration, 'Detail')} />
//                           },
//   ];

//   const [visibleColumns, setVisibleColumns] = useState(columns);

//   const onColumnToggle = (event) => {
//     const selectedColumns = event.value;
//     const orderedSelectedColumns = columns.filter((col) =>
//       selectedColumns.some((sCol) => sCol.field === col.field)
//     );

//     setVisibleColumns(orderedSelectedColumns);
//   };
  
  


//   return (
//     <div>
//       <Dialog header="Assign Employee" visible={displayDialog}  onHide={() => {setDisplayDialog(false); setNote(''); setDescription('');}} modal={true} footer={
//         <>
//           <Button
//             label="Assign"
//             onClick={() => {
//               if (selectedItem && selectedItem.orderId) {
//                 const orderToUpdate = orders.find((order) => order._id === selectedItem.orderId); // find the order to be updated
//                 if (orderToUpdate) {
//                   const updatedOrder = JSON.parse(JSON.stringify(orderToUpdate)); // deep copy of the order

//                   // Find the corresponding item and update it
//                   updatedOrder.orderItems.forEach((orderItem) => {
//                     // Handle cakes
//                     orderItem.cakes.forEach((cake) => {
//                       if (cake._id === selectedItem._id) {
//                         switch (selectedItem.roleType) {
//                           case 'Baker':
//                             cake.assignedBaker = assignee;
//                             cake.bakingDate = new Date(dueDate);
//                             cake.bakingNotes = note;
//                             break;
//                           case 'Crumb Coater':
//                             cake.assignedCrumbCoater = assignee;
//                             cake.crumbCoatDate = new Date(dueDate);
//                             cake.crumbcoatingNote = note;
//                             break;
//                           case 'Decorator':
//                             cake.assignedDecorator = assignee;
//                             cake.decoratingDate = new Date(dueDate);
//                             cake.decoratingNotes = note;
//                             break;
//                           default:
//                             break;
//                         }
//                       }

//                       // Handle toppers
//                       cake.toppers.forEach((topperItem) => {
//                         if (topperItem._id === selectedItem._id && selectedItem.roleType === 'Toppers') {
//                           topperItem.assignedPerson = assignee;
//                           topperItem.dueDate = new Date(dueDate);
//                           topperItem.note = note; 
//                           topperItem.description = description;
//                         }
//                       });

//                       // Handle decorating items
//                       cake.decoratingItems.forEach((decoratingItem) => {
//                         if (decoratingItem._id === selectedItem._id && selectedItem.roleType === 'Details') {
//                           decoratingItem.assignedPerson = assignee;
//                           decoratingItem.dueDate = new Date(dueDate);
//                           decoratingItem.notes = note; 
//                           decoratingItem.description = description;
//                         }
//                       });
//                     });

//                     // Handle cupcakes
//                     orderItem.cupcakes.forEach((cupcake) => {
//                       if (cupcake._id === selectedItem._id) {
//                         switch (selectedItem.roleType) {
//                           case 'Baker':
//                             cupcake.assignedBaker = assignee;
//                             cupcake.bakingDate = new Date(dueDate);
//                             cupcake.bakingNotes = note;
//                             break;
//                           case 'Decorator':
//                             cupcake.assignedDecorator = assignee;
//                             cupcake.decoratingDate = new Date(dueDate);
//                             cupcake.decoratingNotes = note;
//                             break;
//                           default:
//                             break;
//                         }
//                       }
//                     });

//                     // Handle cakePops
//                     orderItem.cakePops.forEach((cakepop) => {
//                       if (cakepop._id === selectedItem._id) {
//                         switch (selectedItem.roleType) {
//                           case 'Baker':
//                             cakepop.assignedBaker = assignee;
//                             cakepop.bakingDate = new Date(dueDate);
//                             cakepop.bakingNotes = note;
//                             break;
//                           case 'Decorator':
//                             cakepop.assignedDecorator = assignee;
//                             cakepop.decoratingDate = new Date(dueDate);
//                             cakepop.decoratingNotes = note;
//                             break;
//                           default:
//                             break;
//                         }
//                       }
//                     });

//                     // Handle cookies
//                     orderItem.cookies.forEach((cookie) => {
//                       if (cookie._id === selectedItem._id) {
//                         switch (selectedItem.roleType) {
//                           case 'Baker':
//                             cookie.assignedBaker = assignee;
//                             cookie.bakingDate = new Date(dueDate);
//                             cookie.bakingNotes = note;
//                             break;
//                           case 'Decorator':
//                             cookie.assignedDecorator = assignee;
//                             cookie.decoratingDate = new Date(dueDate);
//                             cookie.decoratingNotes = note;
//                             break;
//                           default:
//                             break;
//                         }
//                       }
//                     });
//                   });

//                   console.log('Before Save:', orderToUpdate); // Display the order details before save
//                   console.log('Updated Data:', updatedOrder); // Display the order details that are to be saved

//                   OrderService.updateOrder(updatedOrder._id, updatedOrder)
//                     .then((response) => {
//                       console.log('After Save:', response); // Display the response after the save operation is complete
//                       refreshOrders();
//                     })
//                     .catch((error) => {
//                       console.error('Error updating order:', error);
//                     });
//                 }
//               }

//               setDisplayDialog(false);
//               setNote('');
//               setDescription('');
//             }}
//           />
//           <Button label="Cancel" onClick={() => {setDisplayDialog(false); setNote(''); setDescription('');}} className="p-button-text" />
//         </>
//       }>
//         {description && (
//           <>
//             <h3>Description:</h3> 
//             <InputText value={description} onChange={(e) => setDescription(e.target.value)} />
//           </>
//         )}
//         <h3>Select Employee:</h3>
//         <Dropdown value={assignee} options={getEmployeesByRole('Baker')} onChange={(e) => setAssignee(e.value)} placeholder="Select an Employee" optionLabel="label" />
//         <h3>Select Date:</h3>
//         <Calendar value={dueDate} onChange={(e) => setDueDate(e.value)} />
//         <h3>Note:</h3>
//         <InputTextarea value={note} onChange={(e) => setNote(e.target.value)} rows={5} cols={30} autoResize />
//         {console.log('Note:', note)}
//       </Dialog>
//       <div>
//         <Calendar value={dateRange.start} onChange={(e) => setDateRange({ ...dateRange, start: e.value })} />
//         <Calendar value={dateRange.end} onChange={(e) => setDateRange({ ...dateRange, end: e.value })} />
//         <Button label="Sort Asc/Desc" onClick={() => setSorted(!sorted)} />
//         <Button label="Export to CSV" className="p-button-success" style={{ marginLeft: '10px' }}>
//           {csvReport && <CSVLink {...csvReport}></CSVLink>}
//         </Button>
//         <MultiSelect value={visibleColumns} options={columns} optionLabel={("header")} onChange={onColumnToggle} className="w-full sm:w-20rem" display="chip" />
//         <Button label="Toggle Table Height" onClick={() => setScrollHeight(scrollHeight === '500px' ? '1000px' : '500px')} />
//       </div>

//       {sortAndFilterOrders().map((week, index) => {
//         const weekStart = formatISO(startOfWeek(week, { weekStartsOn: 0 }), { representation: 'date' });
//         const weekEnd = formatISO(endOfWeek(week, { weekStartsOn: 0 }), { representation: 'date' });
//         const header = `${formatDay(weekStart)} - ${formatDay(weekEnd)}`;

//         const dueOrders = dueList(week);

//         if (dueOrders.length > 0) {
//           return (
//             <Panel header={header} key={index} toggleable>
//               <div className="p-grid">
//                 <div className="p-col">
//                   <div style={{ marginLeft: '15px', marginRight: '15px' }}>
//                     {fulfillmentList(week).length > 0 && (
//                       <DataTable
//                         value={fulfillmentList(week)}
//                         size="small"
//                         sortMode="multiple"
//                         style={{ maxWidth: '100%' }}
//                         header={
//                           <div className="flex flex-wrap align-items-center justify-content-between gap-2">
//                             <span className="text-xl text-900 font-bold">Orders</span>
//                           </div>
//                         }
//                         stripedRows 
//                         columntoggleicon="pi pi-cog"
//                         columnResizeMode="expand"
//                         resizableColumns
//                         scrollable
//                         scrollHeight={scrollHeight}
//                       >
//                         <Column field="type" header="Type" sortable></Column>
//                         <Column field="scheduledDateTime" header="Scheduled DateTime" sortable></Column>
//                         <Column field="customer.name" header="Customer"></Column>
//                         <Column field="name" header="Order"></Column>
//                         {visibleColumns.map((col) => (
//                           <Column key={col.field} field={col.field} header={col.header} body={col.body} style={{textAlign: 'left', verticalAlign: 'top'}}/>
//                         ))}
//                         {/*<Column field="deliveryAddress" header="Delivery Address" body={addressBodyTemplate}></Column>*/}
//                       </DataTable>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </Panel>
//           );
//         }

//         return null;
//       })}
//     </div>
//   );
// };

// export default WeeklySummary;
